import axios from 'axios'

export default new class Api {
    constructor(config) {
        this.config = config;

        this.url = process.env.VUE_APP_ROOT_API
    }

    request(method, uri, params, options) {
        return axios[method](this.url + '/' + uri.replace(/^\/|\/$/g, ''), typeof params !== 'undefined' ? params : {}, typeof options !== 'undefined' ? options : {});
    }
}
